import {NetworkHop} from "@/lib/types/network.ts";

// A hop "responded" when at least one probe returned a timing. A non-responding
// hop is a traceroute timeout (all "*", no address) and reads as "Failed to
// acknowledge" in the UI.
export const hopResponded = (hop: NetworkHop): boolean => hop.rtt_ms.some((sample) => sample !== null);

// The trace reached the target when the final hop responded; otherwise it ended
// in one or more timed-out hops and the host was never reached.
export const tracerouteReached = (hops: NetworkHop[]): boolean =>
  hops.length > 0 && hopResponded(hops[hops.length - 1]);

// Array index of the last responding hop (the one labelled "stopped here" when
// the host was never reached), or -1 when no hop responded.
export const lastResponderIndex = (hops: NetworkHop[]): number => {
  for (let i = hops.length - 1; i >= 0; i--) {
    if (hopResponded(hops[i])) return i;
  }
  return -1;
};

// Result-banner summary for a probe's traceroute.
export const tracerouteBanner = (hops: NetworkHop[]): {reached: boolean; text: string} => {
  if (tracerouteReached(hops)) {
    return {reached: true, text: `The request reached the host in ${hops[hops.length - 1].index} hops`};
  }
  const responderIdx = lastResponderIndex(hops);
  const stoppedAt = responderIdx >= 0 ? hops[responderIdx].index : 0;
  const lastHop = hops[hops.length - 1].index;
  return {
    reached: false,
    text: `Trace stopped after hop ${stoppedAt} — hops ${stoppedAt + 1}–${lastHop} failed to acknowledge, host was never reached`,
  };
};
